module.exports = __webpack_public_path__ + "static/img/11.ffcc29f4.png";